export const CustomerStyle = {
  noBorder: {
    border: "none",
    padding: "4px 8px",
    textAlign: "center",
    // paddingX: "8px",
  },
  artifactStyle: {
    border: "none",
    padding: "4px 8px",
    textAlign: "center",
    fontWeight: "bold",
    // paddingX: "8px",
  },
  wrapperEmpl: {
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "16px",

  },
  wrapper: {
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "16px",
    // marginY: "16px",
    maxWidth: "100%",
    height: "100%"
  },
  title: {
    paddingTop: "16px",
    paddingLeft: "16px",
    fontWeight: "bold",
  },
  breadcrumbWrapper: {
    paddingLeft: "16px",
    paddingTop: "16px",
    border: "none",
  },
  tableWrapper: {
    margin: "16px",
    marginTop: "24px",
    height: 600,
    border: "none",
    boxShadow: "none",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tableCell: {
    color: "#303131",
    border: "none",
    background: "#F4F6F8",
    fontWeight: "bold",
    textAlign: "center",
    padding: "4px 8px"
  },
  cardWrapper: {
    display: { xs: "block", md: "flex" },
    marginX: "8px",
  },
  cardComponent: {
    flex: 1,
  },
  chartComponent: {
    flex: 1,
    display: "flex",
  },
  card: {
    margin: "8px",
    padding: "8px",
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
  },
  chart: {
    margin: "8px",
    paddingY: "24px",
    paddingX: "12px",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
    flex: 1,
    flexDirection: "column",
  },
  verifyButton: { flex: 1, m: 1, marginTop: "16px" },
  qrButton: { flex: 1, m: 1 },
  box: {
    flex: 1,
    display: "flex",
  },
  paper: {
    margin: "8px",
    paddingY: "24px",
    paddingX: "12px",
    boxShadow:
      "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
    borderRadius: "14px",
    flex: 1,
    flexDirection: "column",
  },
  countWrapper: {
    display: "flex",
    flex: 2,
    justifyContent: "space-between",
    height: "100%",
  },
  count: {
    flex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
  },
  heading: { paddingLeft: "8px", fontWeight: "bold" },
  icon: {
    paddingRight: "12px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  noValidate: {
    padding: "10px",
    gap: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  salesPerson: {
    flex: 1,
    display: { xs: "flex" },
    // mb: { xs: "16px", sm: "auto" },
  },
  textField: {
    display: "flex",


  },
  customerName: {
    flex: 1,
    display: { xs: "flex" },
  },
  customerUser: {
    "&:hover": {
      backgroundColor: "rgba(0,171,85,0.05)",
      cursor: "default",
      "& > *": {
        // color: theme.palette.primary.main,
      },
    },
  },
  insuranceCarrier: {
    border: "none",
    color: "#00ab55",
    cursor: "pointer",
    paddingX: "8px",
  },
};
